module.exports = __webpack_public_path__ + "img/Arzee.388ef8d0.png";